import Component from "gia/Component";
import Env from "../base/env";
import { createCookieNewsletterPopupInactive } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.close = this.ref.close[0];

    this.DOM.close.addEventListener("click", () => {
      Env.$html.classList.remove("popletter-active");
      createCookieNewsletterPopupInactive();
    });

    setTimeout(() => {
      this.detectPopup();
    }, 8000);
  }

  detectPopup() {
    // Check if the newsletter_popup cookie exists
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    };

    // Get the newsletter_popup cookie value
    const newsletterPopupCookie = getCookie("newsletter_popup");

    // Override the global newsletterPopup variable if cookie exists and is set to inactive
    if (newsletterPopupCookie === "inactive") {
      window.newsletterPopup = false;
    }
    if (newsletterPopup) {
      Env.$html.classList.add("popletter-active");
    }
  }

  unmount() {}
}
